import {
  invalidateCachesForAgentToolWrite,
  isAgentToolWriteRequiringCacheRefresh,
  resolveAgentToolCacheContext,
} from '@/features/projects/hooks/agentToolCacheInvalidation';
import {
  useProjectArtifactAutoOpen as useProjectArtifactAutoOpenCore,
  type ProjectArtifactAutoOpenPorts,
} from '@heidi/agents/data';

import { refreshArtifactData } from '../components/refreshArtifactData';
import { artifactFromToolUse } from '../harness/artifactFromTool';

// The app half of the auto-open: the bound artifact deriver, and the cache
// reactions, which reach other domains' caches. Module scope, so each port keeps
// one identity.
const PORTS: ProjectArtifactAutoOpenPorts = {
  artifactFromToolUse,
  refreshArtifactData,
  isAgentToolWriteRequiringCacheRefresh,
  onAgentToolWrite: (item, queryClient, onSessionsChanged) => {
    const { sessionId, patientProfileId, documentId, workflowId, templateId } =
      resolveAgentToolCacheContext(item);
    invalidateCachesForAgentToolWrite({
      queryClient,
      toolName: item.name,
      sessionId,
      patientProfileId,
      documentId,
      workflowId,
      templateId,
      onSessionsChanged,
    });
  },
};

export const useProjectArtifactAutoOpen = (
  args: Parameters<typeof useProjectArtifactAutoOpenCore>[0]
) => useProjectArtifactAutoOpenCore(args, PORTS);
